import React, { useState, useRef } from "react";
import "./Mid-Section.scss";

import ViewInvoicesSelectCard from "./ViewInvoicesSelectCard";
import RecentPaymentsCards from "../../OverView/Mobile-and-Tablet/RecentPaymentsCards";

// Import images from the assets folder
import imageSource1 from "../../../assets/images/abstract-4.png";
import imageSource2 from "../../../assets/images/abstract-5.png";
import PendingIncoicesCard from "./PendingIncoicesCard";
import PayWindowModal from "../../Payments/Mobile-and-Tablet/PayWindowModal";

const MidSectionInvoices = () => {
  //payment popup
  const [showPay, setShowPay] = useState(false);

  //index of select cards
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const cardWidth = 162; // Width of each card in pixels
  const gapWidth = 10; // Gap between cards in pixels

  const moveToCard = (index) => {
    setCurrentIndex(index);
    const totalScrollLeft = index * (cardWidth + gapWidth);
    sliderRef.current.scrollLeft = totalScrollLeft;
  };

  return (
    <div className="mid-section-payments">
      <div className="title">View select</div>
      <div className="view-payment-select-container">
        <div className="slider-container" ref={sliderRef}>
          <div className="slider">
            {[
              {
                Title: "View invoices and make payments",
                Ammount: "5",
                SubText: "Unpaid Invoices",
                imageLink: imageSource1,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["auto", "left top"],
              },
              {
                Title: "View All Payments",
                Ammount: "ksh.10,000",
                SubText: "Payments Made",
                imageLink: imageSource1,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["auto", "left top"],
              },
              {
                Title: "Paid invoices awaiting approval",
                Ammount: "ksh10,000",
                SubText: "Paid Invoices",
                imageLink: imageSource1,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["500% 110%", "center left"],
              },
            ].map((card, index) => (
              <button
                key={index}
                className="payment-card-button"
                onClick={() => moveToCard(index)}
              >
                <ViewInvoicesSelectCard
                  Title={card.Title}
                  Ammount={card.Ammount}
                  SubText={card.SubText}
                  imageLink={card.imageLink}
                  colorOfIcon={card.colorOfIcon}
                  setBackgroundSizeAndPosition={
                    card.setBackgroundSizeAndPosition
                  }
                />
              </button>
            ))}
          </div>
        </div>
      </div>
      {currentIndex === 0 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">Unpaid Invoices</div>
            <PendingIncoicesCard setShowPay={setShowPay} />
          </div>
        </>
      )}

      {currentIndex === 1 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">Recent payments</div>
            <RecentPaymentsCards />
          </div>
        </>
      )}
      {currentIndex === 2 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">
              Paid Invoices awaiting approval
            </div>
            <RecentPaymentsCards awaitingApproval={true} />
          </div>
        </>
      )}

      {showPay && (
        <>
          <div className="modal">
            <PayWindowModal setShowPay={setShowPay} fieldToShow={false} />
          </div>
        </>
      )}
    </div>
  );
};

export default MidSectionInvoices;
